<!-- Page Title Section -->
<div class="ttm-page-title-row" style="background: #293649 url(assets/images/bg-image/guided-search-updated-banne.jpg) no-repeat bottom right;">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-box text-center">
          <div class="page-title-heading">
            <h1 class="title" style="color:white">Contact Us</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Contact Section -->
<div class="site-main">
  <section class="contact-section clearfix">
    <div class="">
      <div class="col-md-12 row">
        <!-- Contact Image Section -->
        <div class="col-md-4" style="margin:auto">
          <div style="text-align:center">
            <img style="width:200px;height:200px;border-radius:50%;" src="assets/images/getintouch.jpg" alt="Get in Touch" />
            <h4>GET IN TOUCH</h4>
          </div>
        </div>

        <!-- Contact Form Section -->
        <div class="col-md-8 spacing-2" style="background: #f0f3f2 !important">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="section-title with-desc text-center clearfix">
                <div class="title-header">
                  <h2 class="title">Drop us a line</h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Angular Reactive Form -->
          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="row ttm-quote-form clearfix">
            <!-- Full Name Field -->
            <div class="col-sm-12">
              <div class="form-group">
                <input 
                  formControlName="firstName"
                  type="text"
                  class="form-control bg-white border input1"
                  placeholder="Full Name*"
                  (keypress)="onlyLetters($event)">
                <span class="form-error" *ngIf="getFieldError('firstName')">
                  {{ getFieldError('firstName') }}
                </span>
              </div>
            </div>

            <!-- Phone Number Field -->
            <div class="col-sm-12">
              <div class="form-group">
                <input 
                  formControlName="phoneNumber"
                  type="tel"
                  placeholder="Phone Number*"
                  maxlength="10"
                  class="input1 form-control bg-white border"
                  (keypress)="onlyNumbers($event)">
                <span class="form-error" *ngIf="getFieldError('phoneNumber')">
                  {{ getFieldError('phoneNumber') }}
                </span>
              </div>
            </div>

            <!-- Email Field -->
            <div class="col-sm-12">
              <div class="form-group">
                <input 
                  formControlName="email"
                  type="email"
                  placeholder="Email Address*"
                  class="input1 form-control bg-white border">
                <span class="form-error" *ngIf="getFieldError('email')">
                  {{ getFieldError('email') }}
                </span>
              </div>
            </div>

            <!-- Message Field -->
            <div class="col-sm-12">
              <div class="form-group">
                <textarea 
                  formControlName="message"
                  rows="5"
                  placeholder="Write your message here…"
                  class="input1 form-control bg-white border"></textarea>
                <span class="form-error" *ngIf="getFieldError('message')">
                  {{ getFieldError('message') }}
                </span>
              </div>
            </div>

            <!-- Company Field (hidden - populated from config) -->
            <input formControlName="company" type="hidden">

            <!-- Loading Indicator -->
            <div class="col-lg-12" style="text-align: center;" *ngIf="isLoading">
              <img src="assets/images/21.gif" alt="Loading...">
              <hr>
            </div>

            <!-- Success Message -->
            <div class="col-lg-12 alert alert-success" role="alert" *ngIf="showSuccess">
              Message Sent Successfully
            </div>

            <!-- Error Message -->
            <div class="col-lg-12 alert alert-danger" role="alert" *ngIf="showError">
              {{ errorMessage }}
            </div>

            <!-- reCAPTCHA Warning -->
            <div class="col-lg-12 alert alert-warning" role="alert" *ngIf="!captchaCompleted">
              Before you proceed to submit, please complete the captcha below.
            </div>

            <!-- reCAPTCHA and Submit Button -->
            <div class="col-md-12">
              <div class="text-center">
                <!-- reCAPTCHA Widget -->
                <div class="g-recaptcha mb-3" 
                     data-sitekey="6Lfpq9MiAAAAAJ2aFQwunSndFOp-vBXC7CEBTAIw"
                     data-callback="onCaptchaSuccess"
                     data-expired-callback="onCaptchaExpired">
                </div>
                
                <!-- Captcha Error Message -->
                <div *ngIf="captchaError" class="alert alert-danger mb-3">
                  Please complete the reCAPTCHA verification.
                </div>

                <!-- Submit Button -->
                <button 
                  type="submit"
                  [disabled]="isLoading || !captchaCompleted"
                  style="background-color: white; border-color: #009b7c; color: #009b7c;"
                  class="submit_button btn ttm-btn ttm-btn1 ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor">
                  {{ isLoading ? 'Submitting...' : 'Submit' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
